export const GET_EXTERNAL_CONTACT_TRANSACTIONS_START =
  'GET_EXTERNAL_CONTACT_TRANSACTIONS_START';
export const GET_EXTERNAL_CONTACT_TRANSACTIONS_ERROR =
  'GET_EXTERNAL_CONTACT_TRANSACTIONS_ERROR';
export const GET_EXTERNAL_CONTACT_TRANSACTIONS_SUCCESS =
  'GET_EXTERNAL_CONTACT_TRANSACTIONS_SUCCESS';
